import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { eventsAPI } from '../api';

export default function HomePage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eventsAPI.list().then(r => setEvents(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Header */}
      <div style={{ background: '#1A2744', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 40, height: 40, objectFit: 'contain' }} />
          <div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 18, fontFamily: "'Playfair Display', serif" }}>Tikoo</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11 }}>by Omogusii Warriors Welfare</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <Link to="/my-tickets" style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, padding: '8px 16px' }}>My Tickets</Link>
          <Link to="/organizer/login" style={{ background: '#E8521A', color: '#fff', padding: '8px 16px', borderRadius: 8, fontSize: 14, fontWeight: 600 }}>Organizer Login</Link>
        </div>
      </div>

      {/* Hero */}
      <div style={{ background: 'linear-gradient(135deg,#1A2744,#2D3A5F)', padding: '60px 24px', textAlign: 'center' }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", color: '#fff', fontSize: 42, margin: '0 0 12px' }}>🎟️ Find Your Next Event</h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 18, margin: 0 }}>Buy tickets securely via M-Pesa</p>
      </div>

      {/* Events */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#9CA3AF' }}>Loading events...</div>
        ) : events.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🎭</div>
            <h3 style={{ color: '#374151' }}>No events yet</h3>
            <p style={{ color: '#9CA3AF' }}>Check back soon for upcoming events</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 24 }}>
            {events.map(event => (
              <Link to={`/event/${event.id}`} key={event.id}
                style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', transition: 'transform 0.2s', display: 'block', color: 'inherit' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
                {event.banner_url ? (
                  <img src={event.banner_url} alt={event.name} style={{ width: '100%', height: 180, objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: '100%', height: 180, background: 'linear-gradient(135deg,#1A2744,#E8521A)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 48 }}>🎟️</div>
                )}
                <div style={{ padding: 20 }}>
                  <div style={{ fontSize: 12, color: '#E8521A', fontWeight: 700, marginBottom: 6, textTransform: 'uppercase' }}>{event.organizer_name}</div>
                  <h3 style={{ margin: '0 0 8px', fontSize: 18, color: '#1A2744', fontFamily: "'Playfair Display', serif" }}>{event.name}</h3>
                  <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 4 }}>📅 {new Date(event.date).toLocaleDateString('en-KE', { dateStyle: 'long' })} · ⏰ {event.time}</div>
                  <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 16 }}>📍 {event.venue}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      {event.min_price === 0 ? <span style={{ color: '#2D7D32', fontWeight: 700 }}>Free</span> :
                        <span style={{ color: '#1A2744', fontWeight: 700 }}>From KSh {parseInt(event.min_price).toLocaleString()}</span>}
                    </div>
                    <span style={{ background: '#E8521A', color: '#fff', padding: '6px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600 }}>Get Tickets →</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div style={{ background: '#1A2744', padding: '24px', textAlign: 'center', marginTop: 40 }}>
        <p style={{ color: 'rgba(255,255,255,0.4)', margin: 0, fontSize: 13 }}>Tikoo · Powered by Omogusii Warriors Welfare · {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}
